export default __webpack_public_path__ + "static/media/home_top.fe890e9b.svg";